import axios from "axios"

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true})


export const fetchLogs = () => API.get(`/logs`);
export const sendLog = (logDetails) => API.put(`/logs`, {data: logDetails});
// LogsApi.js
export const fetchLogsFiltered = (params) => API.get('/logs/filtered', { params });
export const searchLogsApi = (query) => API.get('/logs/search', { params: { query } });
export const fetchActiveUsers = (limit = 10) => API.get('/logs/active-users', { params: { limit } });
export const fetchActiveGuests = (limit = 10) => API.get('/logs/guests', { params: { limit } });
export const fetchActionCounts = (timescale) => API.get(`/logs/actions/${timescale}`);
export const fetchTotals = () => API.get('/logs/totals');
export const fetchPageViews = (params) => API.get('/logs/page-views', { params });
export const fetchSessionMetrics = (params) => API.get('/logs/sessions', { params });
export const fetchAvgTimeOnPage = (params) => API.get('/logs/avg-time', { params });
export const fetchBounceData = (params) => API.get('/logs/bounces', { params });
export const fetchTrafficSources = (params) => API.get('/logs/sources', { params });
export const fetchConversionMetrics = () => API.get('/logs/conversions');